import { render, staticRenderFns } from "./NotificationOfferRecipient.vue?vue&type=template&id=93be337e&"
import script from "./NotificationOfferRecipient.vue?vue&type=script&lang=ts&"
export * from "./NotificationOfferRecipient.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationOfferRecipient.vue?vue&type=style&index=0&id=93be337e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports